import type { ReactNode } from 'react'
import { ListScroll, ListColumn } from 'admination-react'
import { ListShell } from '@/core/components/list/ListShell'
import { useViewInput, type ViewInputState } from './useViewInput'
import type { ViewConfig } from './viewConfig'

export function ListView<T>({
  items,
  config,
  viewState,
  selectedKey,
  onRowClick,
  renderExpansion,

  flatFilter,

  groupOrder,
  groupHeader,

  groupTrailing,

  header,
}: {
  items: T[]
  config: ViewConfig<T>
  viewState: ViewInputState
  selectedKey?: string | null
  onRowClick?: (item: T, e: React.MouseEvent<HTMLElement>) => void
  renderExpansion?: (item: T) => ReactNode
  flatFilter?: (item: T) => boolean
  groupOrder?: string[]
  groupHeader?: (groupId: string, count: number) => ReactNode
  groupTrailing?: (groupId: string, count: number) => ReactNode
  header?: ReactNode
}) {
  const { rows, byGroup } = useViewInput(items, config, viewState)

  const grouping =
    !flatFilter && config.groupBy && groupOrder && groupHeader
      ? {
          groupBy: config.groupBy,
          groups: groupOrder.map((id) => {
            const count = byGroup?.get(id)?.length ?? 0
            return {
              id,
              header: groupHeader(id, count),
              trailing: groupTrailing?.(id, count),
            }
          }),
        }
      : undefined

  return (

    <ListScroll>
      <ListColumn className="list-column--flush-left">
        {header}
        <ListShell
          rows={rows}
          {...(flatFilter ? { filter: flatFilter } : grouping ? grouping : {})}
          title={config.title}
          properties={config.properties}
          rowKey={config.rowKey}
          onRowClick={onRowClick}
          selectedKey={selectedKey ?? null}
          emptyText={config.emptyText}
          cards={config.cards}
          renderExpansion={renderExpansion}
        />
      </ListColumn>
    </ListScroll>
  )
}
